
/**
 * Chat thread created or existing returned with full details
 */
export type CreateChatThread200AllOfFive = { [key: string]: unknown };
